import * as React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Container from "./container";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient();

const container = document.getElementById("searchroot");
const root = createRoot(container!);
root.render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <Container />
        </QueryClientProvider>
    </StrictMode>,
);
